(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/internal/shared/api-paths.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/internal/shared/api-paths.js');

'use strict';

const API_PATHS = {
  activeCampaigns: () => '/draw/1/campaigns',
  activeCampaignsByProduct: product => "/draw/1/campaign/".concat(product),
  campaignByDraw: (product, drawNumber) => "/draw/1/campaign/".concat(product, "/").concat(drawNumber),
  campaignDatePicker: (product, year, month) => "/draw/1/campaign/datepicker?year=".concat(year, "&month=").concat(month, "&product=").concat(product)
};
if (svs.isServer) {
  module.exports = API_PATHS;
} else {
  svs.numbergames.campaign.internal.API_PATHS = API_PATHS;
}

 })(window);